import React from 'react'

import View from './View.jsx'

const Container = () => {
  return <View title="Cadastrar Condominio" />
}

export default Container
